import script from "./artmisadsDropdownMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./artmisadsDropdownMenu.vue?vue&type=script&setup=true&lang=js"

import "./artmisadsDropdownMenu.vue?vue&type=style&index=0&id=479ed468&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-479ed468"]])

export default __exports__